<div class="user-menu">
  <div class="user-menu__header">
    <div class="user-menu__header__option">
      <div class="user-menu__header__option__logo">{{ initials() }}</div>
      <div class="user-menu__header__option__data">
        <div class="user-menu__header__option__data__name">{{ fullName() }}</div>
        @if (email()) {
          <div class="user-menu__header__option__data__email">
            {{ email() }}
          </div>
        }
        @if (cargo()) {
          <div class="user-menu__header__option__data__cargo">
            {{ cargo() }}
          </div>
        }
      </div>
    </div>
  </div>

  <div class="user-menu__section">
    <div class="user-menu__submenu-anchor">
      <button
        type="button"
        class="user-menu__option"
        (click)="toggleLanguageMenu()"
      >
        <img
          src="public/icons/common/language-icon.svg"
          class="user-menu__option__icon-img"
          [attr.alt]="'USER_MENU.LANGUAGE' | transloco"
        />
        <span class="user-menu__option__text">
          <span class="user-menu__option__title">{{
            currentLanguageName()
          }}</span>
        </span>
        <img
          src="public/icons/navigation/next-page-icon.svg"
          alt=""
          class="user-menu__options__icon"
        />
      </button>

      @if (isLanguageMenuOpen()) {
        <app-user-options-menu
          [title]="'USER_MENU.LANGUAGE' | transloco"
          [options]="languageOptions"
          [selectedValue]="currentLanguage()"
          (optionSelectedEvent)="onLanguageSelected($event)"
        />
      }
    </div>

    <button type="button" class="user-menu__option" (click)="openChangePassword()">
      <img
        src="public/icons/common/key-icon.svg"
        class="user-menu__option__icon-img"
        [attr.alt]="'USER_MENU.CHANGE_PASSWORD' | transloco"
      />
      <span class="user-menu__option__text">
        <span class="user-menu__option__title">{{
          'USER_MENU.CHANGE_PASSWORD' | transloco
        }}</span>
      </span>
    </button>
  </div>

  <div class="user-menu__appearance">
    <div class="user-menu__appearance-title">
      {{ 'USER_MENU.APPEARANCE' | transloco }}
    </div>
    <div class="user-menu__appearance-grid">
      @for (option of themeOptions; track option.value) {
        <button
          type="button"
          [class.user-menu__appearance-btn--on]="themeMode() === option.value"
          [attr.aria-pressed]="themeMode() === option.value"
          (click)="setTheme(option.value)"
        >
          <span class="material-symbols-outlined" aria-hidden="true">{{
            option.icon
          }}</span
          ><span>{{ option.labelKey | transloco }}</span>
        </button>
      }
    </div>
  </div>

  <div class="user-menu__separator"></div>

  <button
    type="button"
    class="user-menu__option user-menu__option--danger"
    (click)="logout()"
  >
    <img
      src="public/icons/common/logout-icon.svg"
      class="user-menu__option__icon-img"
      [attr.alt]="'USER_MENU.LOGOUT' | transloco"
    />
    <span class="user-menu__option__text">
      <span class="user-menu__option__title">{{
        'USER_MENU.LOGOUT' | transloco
      }}</span>
    </span>
  </button>
</div>
